import { jsx as _jsx } from 'react/jsx-runtime';
export const IconWarningFilled = (props) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.862 2.493a1 1 0 0 0-1.724 0l-10 17A1 1 0 0 0 2 21h20a1 1 0 0 0 .862-1.507l-10-17ZM12 8a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm0 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
      fill: 'currentColor',
    }),
  });
IconWarningFilled.displayName = 'IconWarningFilled';
